import { connect } from "react-redux";

export function createMapStateToProps() {
    return (state) => {
        return {
            bloombergSiteUrl: state.config.bloombergSiteUrl
        };
    };
}

function LayoutContainer(component) {
    return connect(
        createMapStateToProps(),
        null
    )(component);
}

export default LayoutContainer;
